import type { DeepPartial } from '@luna/utils-ts';

import type { SavingsConfig } from '../ProductsConfig';
import { settingsDetails } from './settings-details-config/RS';

export const savings: DeepPartial<SavingsConfig> = {
    settingsDetails,
    layout: {
        productInfo: {
            showDisposableAndBalanceAmounts: true,
        },
    },
    useDisposableInsteadOfBalance: true,
};
